import { render, staticRenderFns } from "./RecepcionDashboardProductosLote.vue?vue&type=template&id=506e168d&scoped=true&"
import script from "./RecepcionDashboardProductosLote.vue?vue&type=script&lang=js&"
export * from "./RecepcionDashboardProductosLote.vue?vue&type=script&lang=js&"
import style0 from "./RecepcionDashboardProductosLote.vue?vue&type=style&index=0&id=506e168d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e168d",
  null
  
)

export default component.exports